// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_HTLKv","bundle-deals":"bundle-deals_RcYp0","iconfont":"iconfont","tag":"tag_eOsei"};